/* eslint-disable react-hooks/rules-of-hooks */
import { Box, Typography, useTheme } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { useRecoilValue } from "recoil";
import useStyles from "../containers/data/forms/forms-styles";
import { ControlState } from "../models/flexible/control-state";
import { userPersonalInfoState } from "../store/user";
import { GeneralFieldController } from "./general-field-controller";

export class AddedByFieldController extends GeneralFieldController {
	customRenderContent(): React.ReactElement {
		const styles = useStyles();
		const { palette } = useTheme();
		const { t } = useTranslation();
		const currentUser = useRecoilValue(userPersonalInfoState);
		const creatorUser = this.parent.context.flexEntity?.createdBy;
		const creatorName = this.parent.context.flexEntity
			? creatorUser && `${creatorUser.firstName} ${creatorUser.lastName}`
			: `${currentUser.firstName} ${currentUser.lastName}`;

		return (
			<Box className={styles.colMedium} pr={5} paddingY={2.5} pl={1.5}>
				<Typography variant="caption" style={{ color: palette.enabledHeader.main }}>
					{t("added-by")}
				</Typography>
				<Typography style={{ color: palette.text.disabled }}>{creatorName}</Typography>
			</Box>
		);
	}

	override useControlState(path: string): ControlState {
		return "enabled";
	}
}
